// Pure: is the board's data within the freshness limit? Times are same-day "h:mm AM/PM" strings.
const toMinutes = (time) => {
  const [, h, m, period] = time.match(/^(\d{1,2}):(\d{2})\s*(AM|PM)$/i);
  return ((Number(h) % 12) + (period.toUpperCase() === "PM" ? 12 : 0)) * 60 + Number(m);
};

export const isBoardFresh = (asOf, now, limitMinutes) => toMinutes(now) - toMinutes(asOf) <= limitMinutes;
